module.exports = __webpack_public_path__ + "img/3K.b75fed8c.png";